import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
//import { useTracking } from "react-tracking";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormRender from "../../../Fields/FormRender";
import SaveAthleteDataView from "./PaymentViews/SaveAthleteDataView";
import { updateUserAtribute } from "../../../../data-store/actions/atlete-actions";
import { getStandarInputsData } from "./StandarInputsData";
import { translateForm } from "../../../Fields/FieldUtils";
import CurrencyPayment from "./PaymentViews/CurrencyPayment";
import AditionalInputs from "./PaymentViews/AditionalInputs";
import AditionalProducts from "./PaymentViews/AditionalProducts";
import FieldEvent from "./FieldEvent/FieldEvent";
import PaymentDetailRegistryForm from "./PaymentViews/PaymentDetailRegistryForm";
import PaymentsView from "./PaymentViews/PaymentsView";
import OxxoConfirmation from "./PaymentViews/OxxoConfirmation";
import RegistryConfirmation from "./RegistryConfirmation/RegistryConfirmation";
import GroupRegistrySummary from "./PaymentViews/GroupRegistrySummary";
import {
  resetRegistryParticipantData,
  guardarAtletaPendienteEnGrupo,
  marcarAtletaRemovidoDelGrupo,
  fijarParticipanteActual,
} from "../../../../data-store/actions/registry-actions";
import { useTracking } from "react-tracking";
import { useLocation } from "react-router-dom";
import * as fb from "../../../../firebase/firebasejs";

// Registro de varios atletas antes de un solo pago: los inscritoKey del
// grupo en progreso se guardan en localStorage para poder recuperarlos si
// se recarga la página o se cierra el navegador por error. Namespaced por
// evento porque el mismo dispositivo puede usarse para inscribirse a varios
// eventos distintos.
function claveGrupoLocalStorage(eventoIndex) {
  return `dashport_grupo_${eventoIndex}`;
}
function leerGrupoLocalStorage(eventoIndex) {
  try {
    const raw = window.localStorage.getItem(claveGrupoLocalStorage(eventoIndex));
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}
function guardarGrupoLocalStorage(eventoIndex, inscritoKeys) {
  try {
    window.localStorage.setItem(
      claveGrupoLocalStorage(eventoIndex),
      JSON.stringify(inscritoKeys)
    );
  } catch (e) {
    // localStorage no disponible (modo privado, etc.) — no es crítico, el
    // grupo simplemente no se podrá recuperar tras un reload.
  }
}
function limpiarGrupoLocalStorage(eventoIndex) {
  try {
    window.localStorage.removeItem(claveGrupoLocalStorage(eventoIndex));
  } catch (e) {
    // sin acción
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 600,
    //    margin: "10px",
    backgroundColor: theme.palette.background.default,
  },
  paper: {
    padding: "15px",
    backgroundColor: "#283747",
  },
  color: {
    padding: "15px",
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function EventRegistryPublicForm(props) {
  const { eventIdDashport, title, name, eventLogo, params, titlesColors } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation("inscripcion");
  const { trackEvent } = useTracking();
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  const userID = useSelector((state) => state.atlete.userID);
  const athleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const eventoIndex = "evento_" + eventDetail.iDEvento;
  const eventSubEventsRegistry = useSelector(
    (state) => state.events.eventSubEventsRegistry
  );
  const registryConfigurationData = useSelector(
    (state) => state.registry.registryConfiguration
  );
  const registryParticipantKey = useSelector(
    (state) => state.registry.registryParticipantKey
  );
  const registryParticipantData = useSelector(
    (state) => state.registry.registryParticipantData
  );

  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const [personalData, setPersonalData] = useState(null);
  const [personalExtraData, setPersonalExtraData] = useState(null);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [showSecondForm, setShowSecondForm] = useState(true);
  const [subEvent, setSubEvent] = useState(null);
  const [successPayment, setSuccessPayment] = useState(false);
  const [oxxoPayment, setOxxoPayment] = useState(false);
  const [paymentView, setPaymentView] = useState(false);

  const [currentOrder, setCurrentOrder] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [currency, setCurrency] = useState({
    codigo: "MXN",
    tipo: "base",
    tipoCambio: 1,
    texto: "Pesos Méxicanos",
    cambioAPeso: "1",
  });
  const [currencyBase, setCurrencyBase] = useState({
    codigo: "MXN",
    tipo: "base",
    tipoCambio: 1,
    texto: "Pesos Méxicanos",
    cambioAPeso: "1",
  });

  // Registro de varios atletas antes de un solo pago: grupoAtletas[0] es
  // siempre el "líder" (el primero que llenó sus datos) — es al único al
  // que se le cobra de verdad, ver GroupRegistrySummary.jsx.
  const [grupoAtletas, setGrupoAtletas] = useState([]);
  const [showGroupSummary, setShowGroupSummary] = useState(false);
  const [avisoGrupoRecuperado, setAvisoGrupoRecuperado] = useState(0);

  useEffect(() => {
    if (registryConfigurationData.configuracion.moneda) {
      setCurrency(
        Object.values(registryConfigurationData.configuracion.moneda).filter(
          (a) => a.tipo === "base"
        )[0]
      );
      setCurrencyBase(
        Object.values(registryConfigurationData.configuracion.moneda).filter(
          (a) => a.tipo === "base"
        )[0]
      );
    }
    dispatch(resetRegistryParticipantData());

    // Si el navegador se recargó a medio armar un grupo, se recuperan los
    // atletas que sigan pendientes (los ya pagados o borrados se descartan).
    const keysGuardadas = leerGrupoLocalStorage(eventoIndex);
    if (keysGuardadas.length > 0) {
      Promise.all(
        keysGuardadas.map((inscritoKey) =>
          fb.db
            .ref(
              `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}${inscritoKey}`
            )
            .once("value")
            .then((snap) => ({ inscritoKey, atleteData: snap.val() }))
        )
      ).then((resultados) => {
        const recuperados = resultados
          .filter(
            (r) =>
              r.atleteData &&
              !r.atleteData.borrado &&
              r.atleteData.statusPago &&
              r.atleteData.statusPago.status === "pendiente"
          )
          .map((r) => ({
            inscritoKey: r.inscritoKey,
            atleteData: r.atleteData,
            resumen: resumenDeAtleta(r.atleteData),
          }));

        if (recuperados.length > 0) {
          setGrupoAtletas(recuperados);
          setAvisoGrupoRecuperado(recuperados.length);
          guardarGrupoLocalStorage(
            eventoIndex,
            recuperados.map((r) => r.inscritoKey)
          );
        } else {
          limpiarGrupoLocalStorage(eventoIndex);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function resumenDeAtleta(atleteData) {
    const modIndex = "modalidad_" + atleteData.modalidad;
    const distancia =
      eventSubEventsRegistry &&
      eventSubEventsRegistry[modIndex] &&
      eventSubEventsRegistry[modIndex].descripcionModalidad;
    let categoriaLabel = atleteData.categoria;
    try {
      categoriaLabel =
        eventSubEventsRegistry[modIndex].ramaCat["rama_" + atleteData.rama]
          .categorias["categoria_" + atleteData.categoria].nombreCategoria;
    } catch (e) {
      // si no se encuentra el label se deja el id crudo, no es crítico
    }
    return {
      nombres: atleteData.nombres,
      apellidos: atleteData.apellidos,
      distancia: distancia || "",
      rama: atleteData.rama,
      categoria: categoriaLabel,
    };
  }

  function resetFormParaSiguienteAtleta() {
    setPersonalData(null);
    setPersonalExtraData(null);
    setSubEvent(null);
    setCurrentOrder(false);
    setShowPaymentForm(false);
    setShowSecondForm(true);
    setShowProducts(false);
  }

  async function agregarAtletaAlGrupo() {
    // el atleta se guarda sin su comisión individual — la comisión se
    // calcula UNA sola vez, sobre el total consolidado, al armar el
    // resumen del grupo (GroupRegistrySummary.jsx).
    const ordenSinComision = currentOrder.order.filter((a) => a.code !== "comision");
    const datosAGuardar = { ...currentOrder, order: ordenSinComision };
    const { inscritoKey, atleteData } = await guardarAtletaPendienteEnGrupo(
      eventoIndex,
      datosAGuardar,
      userID
    );
    const nuevoGrupo = [
      ...grupoAtletas,
      { inscritoKey, atleteData, resumen: resumenDeAtleta(atleteData) },
    ];
    setGrupoAtletas(nuevoGrupo);
    guardarGrupoLocalStorage(eventoIndex, nuevoGrupo.map((a) => a.inscritoKey));
    resetFormParaSiguienteAtleta();
  }

  async function finalizarGrupoConEsteAtleta() {
    const ordenSinComision = currentOrder.order.filter((a) => a.code !== "comision");
    const datosAGuardar = { ...currentOrder, order: ordenSinComision };
    const { inscritoKey, atleteData } = await guardarAtletaPendienteEnGrupo(
      eventoIndex,
      datosAGuardar,
      userID
    );
    const nuevoGrupo = [
      ...grupoAtletas,
      { inscritoKey, atleteData, resumen: resumenDeAtleta(atleteData) },
    ];
    setGrupoAtletas(nuevoGrupo);
    guardarGrupoLocalStorage(eventoIndex, nuevoGrupo.map((a) => a.inscritoKey));
    setShowGroupSummary(true);
  }

  function onListoGrupo(ordenConsolidada, lider) {
    const dataLider = { ...lider.atleteData, order: ordenConsolidada };
    dispatch(fijarParticipanteActual(eventoIndex, lider.inscritoKey, dataLider));
    setCurrentOrder(dataLider);
    setPersonalData({
      nombres: dataLider.nombres,
      apellidos: dataLider.apellidos,
      correo: dataLider.correo,
      telefono: dataLider.telefono,
    });
    limpiarGrupoLocalStorage(eventoIndex);
    setShowGroupSummary(false);
    setPaymentView(true);
  }

  function quitarDelGrupo(inscritoKeyAQuitar) {
    const nuevoGrupo = grupoAtletas.filter((a) => a.inscritoKey !== inscritoKeyAQuitar);
    setGrupoAtletas(nuevoGrupo);
    if (nuevoGrupo.length > 0) {
      guardarGrupoLocalStorage(eventoIndex, nuevoGrupo.map((a) => a.inscritoKey));
    } else {
      limpiarGrupoLocalStorage(eventoIndex);
      setShowGroupSummary(false);
    }
  }

  function cancelarGrupo() {
    grupoAtletas.forEach((a) => marcarAtletaRemovidoDelGrupo(eventoIndex, a.inscritoKey));
    setGrupoAtletas([]);
    limpiarGrupoLocalStorage(eventoIndex);
    setShowGroupSummary(false);
    resetFormParaSiguienteAtleta();
  }

  let form = setAthleteDataToForm(
    translateForm(getStandarInputsData(t)),
    athleteAccount
  );
  if (form.fechaNacimiento && registryConfigurationData) {
    form.fechaNacimiento = {
      ...form.fechaNacimiento,
      mostrarEdadEvento: true,
      fechaEvento: eventDetail.fechaEvento,
      edadActualEvento: registryConfigurationData.configuracion.edadActual,
    };
  }
  let formExtra = registryConfigurationData
    ? translateForm(registryConfigurationData.gruposFormularios.general)
    : {};

  let formDistanceAndExtra = {
    distancia: {
      order: 0,
      label: "Distancia",
      errorMessage: "",
      fieldName: "modalidad",
      type: "event",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
      currentAge: registryConfigurationData.configuracion.edadActual,
      currency: currency,
      birth: personalData ? personalData.fechaNacimiento : 0,
      gender: personalData ? (personalData.genero === "M" ? "V" : "F") : "",
      eventDate: eventDetail.fechaEvento,
      optionsArray: eventSubEventsRegistry ? eventSubEventsRegistry : {},
    },
    ...formExtra,
  };
  console.log("formDistanceAndExtra", formDistanceAndExtra);
  console.log("currentOrder", currentOrder);
  console.log("edad1", registryConfigurationData.configuracion.edadActual);

  function setAthleteDataToForm(form, athleteAccount) {
    if (registryConfigurationData.configuracion.separarApellidos) {
      delete form.apellidos;
    } else {
      delete form.apellidoMaterno;
      delete form.apellidoPaterno;
    }
    let newForm = {};
    for (var i in form) {
      console.log(form[i]);
      newForm[i] = {
        ...form[i],
        defaultValue:
          athleteAccount && athleteAccount[form[i].fieldName] !== undefined
            ? athleteAccount[form[i].fieldName]
            : "",
      };
    }

    return newForm;
  }

  function confirmPersonalData(data) {
    // Guardo los datos del atelta en su perfil en caso que no existan datos previos en ese campo
    for (var i in data) {
      if (
        athleteAccount !== null &&
        athleteAccount !== undefined &&
        athleteAccount[i] === undefined
      ) {
        dispatch(updateUserAtribute(userID, { [i]: data[i] }));
      }
    }
    const tkl = query.get("tkl");

    trackEvent({
      eventName: "evento_" + eventDetail.iDEvento,
      typeEvent: "Lead",
      params: {
        label: "Lead",
        tkl: tkl || "direct",
        eventName: eventDetail.nombreEvento,
        facebookPixel: eventDetail.facebookPixel || false,
        gaId: eventDetail.gaId || false,
      },
    });
    console.log("data", data);
    setPersonalData({ ...data, tkl: tkl || "direct" });
  }
  function confirmPersonalExtraData(data) {
    setPersonalExtraData(data);
  }

  console.log("currentOrder", personalData);
  function confirmSubEvent(data) {
    // funcion para generar el objeto total incluyendo Distancia, Rama y Categoría seleccionada
    console.log("confirmSubEvent", data);
    setSubEvent(data);

    if (data.category) {
      const fechaNacimiento = personalData.fechaNacimiento.split("-");

      const participantDetail = {
        nombres: personalData.nombres,
        apellidos: personalData.apellidos,
        rama: personalData.genero === "M" ? "V" : personalData.genero,
        correo: personalData.correo,
        telefono: personalData.telefono,
        fechaNacimiento:
          fechaNacimiento[0] +
          "/" +
          fechaNacimiento[1] +
          "/" +
          fechaNacimiento[2],
        modalidad: data.distance,
        categoria: data.category,
        fechaRegistro: "PENDIENTE",
        mails: {
          sendMail: false,
        },
        monedaAUsar: currency,
        monedaBase: currencyBase,
        order: [
          {
            code: "insc",
            description: t("descripcionOrdenInscripcion", {
              evento: eventDetail.nombreEvento,
              modalidad:
                eventSubEventsRegistry["modalidad_" + data.distance]
                  .descripcionModalidad,
            }),
            name: eventDetail.nombreEvento,
            precioKey: "precio_1",
            quantity: 1,
            unit_price:
              eventSubEventsRegistry["modalidad_" + data.distance]
                .configModalidad.precio.preventa_1.precio_1,
          },
        ],
        tipoRegistro: 1,
        usuarioRegistra: "No registrado",
        versionForm: "2.0",
      };

      setCurrentOrder({
        ...participantDetail,
        order: addComition(participantDetail.order),
      });
      console.log("confirmSubEvent", participantDetail);
      console.log("confirmSubEvent", currentOrder);
      console.log("confirmSubEvent", eventSubEventsRegistry);

      setShowPaymentForm(true);
      setShowSecondForm(false);
    } else {
      //dispatch(showSnackbar(true, "Selecciona una Categoría", 5000));
    }
  }
  function callbackInputs(data) {
    // para guardar los datos de los campos adicionales
    console.log("callbackInputs", data);
    console.log("confirmSubEvent", currentOrder);
    setShowProducts(true);
    setCurrentOrder({ ...currentOrder, ...data });
    setTimeout(() => {
      console.log("callbackInputs", currentOrder);
    }, 1000);
  }
  function callbackProducts(producto, item, add) {
    // para ajustar la orden con los datos de los productos comprados
    console.log("confirmSubEvent", item);
    console.log("confirmSubEvent", currentOrder.order);

    let order = currentOrder.order;
    console.log("find", item, order);
    const find = order.filter((a) => a.code === item.code);
    if (add) {
      // si oprimo el botón de agregar producto valido si ya está, en caso de estar aumento la cantidad
      console.log("find", find);
      if (find.length === 0) {
        // si no está lo agrego
        order.push(item);
      } else {
        // en caso de estar aumento la cantidad
        order = order.filter((a) => a.code !== item.code);
        console.log("find", find[0]);
        order.push({ ...find[0], quantity: find[0].quantity + 1 });
      }
    } else {
      // si deseo eliminar el producto
      if (find.length > 0) {
        if (find[0].quantity === 1) {
          order = order.filter((a) => a.code !== item.code);
        } else {
          // en caso de estar disminuyo la cantidad la cantidad
          order = order.filter((a) => a.code !== item.code);
          order.push({ ...find[0], quantity: find[0].quantity - 1 });
        }
      }
    }
    console.log("find", order);

    console.log("confirmSubEvent", order);

    const currentOrderNew = { ...currentOrder, order: addComition(order) };

    setCurrentOrder(currentOrderNew);
    console.log("confirmSubEvent", currentOrder);
  }
  function addComition(order) {
    console.log("confirmSubEvent", order);
    // Funcion para calcular la comision y agregarla al final de la orden
    let orderWithoutComition = order.filter((a) => a.code !== "comision");
    console.log("confirmSubEvent", orderWithoutComition);
    let comision = 0;
    for (var i in orderWithoutComition) {
      comision =
        comision +
        orderWithoutComition[i].quantity * orderWithoutComition[i].unit_price;
    }
    comision =
      Math.round(
        comision *
        registryConfigurationData.configuracion.formasDePago.comisionGlobal *
        100
      ) / 100;
    // Math.round(
    //   orderWithoutComition.reduce(
    //     (a, c) => c.unit_price * c.quantity + a.unit_price * a.quantity
    //   ) *
    //     registryConfigurationData.configuracion.formasDePago.comisionGlobal *
    //     100
    // ) / 100;
    console.log("confirmSubEvent", comision);
    orderWithoutComition.push({
      code: "comision",
      description: t("comisionDescripcion"),
      name: t("comisionNombre"),
      precioKey: "",
      quantity: 1,
      unit_price: comision,
    });

    console.log("confirmSubEvent", orderWithoutComition);
    return orderWithoutComition;
  }

  const sendPayment = (success, oxxoObject) => {
    // TODO: mostrar confirmación y cerrar
    if (success) {
      setSuccessPayment(true);
      setOxxoPayment(oxxoObject);
      setPaymentView(false);
    }
    console.log(success);
  };

  if (successPayment) {
    return (
      <Grid
        container
        direction="row"
        wrap="wrap"
        alignItems="center"
        alignContent="center"
        className={classes.root}
      >
        <Grid item xs={12} style={{ padding: "15px", textAlign: "center" }}>
          <Typography
            color="primary"
            gutterBottom
            variant={"h4"}
            component="h2"
          >
            {t("felicidades", { nombre: personalData.nombres })}
          </Typography>
        </Grid>

        {!oxxoPayment && (
          <Grid item xs={12} style={{ padding: "15px", textAlign: "center" }}>
            <Typography
              color="primary"
              gutterBottom
              variant={"subtitle"}
              component="h5"
            >
              {t("detalleCompra")}
            </Typography>
            <RegistryConfirmation
              tipo={1}
              eventDetail={eventDetail}
              registryParticipantKeyConfirm={registryParticipantKey}
              registryParticipantDataConfirm={registryParticipantData}
              eventSubEventsRegistry={eventSubEventsRegistry}
              registryConfiguration={registryConfigurationData}
            />
          </Grid>
        )}
        {oxxoPayment && (
          <Grid item xs={12} style={{ padding: "15px", textAlign: "center" }}>
            <OxxoConfirmation responseData={oxxoPayment} />
          </Grid>
        )}
      </Grid>
    );
  }

  if (showGroupSummary) {
    return (
      <Grid
        container
        direction="row"
        wrap="wrap"
        alignItems="center"
        alignContent="center"
        className={classes.root}
      >
        <GroupRegistrySummary
          grupoAtletas={grupoAtletas}
          eventoIndex={eventoIndex}
          currency={currency}
          currencyBase={currencyBase}
          registryConfigurationData={registryConfigurationData}
          onQuitarAtleta={quitarDelGrupo}
          onCancelarGrupo={cancelarGrupo}
          onListo={onListoGrupo}
        />
      </Grid>
    );
  }

  if (paymentView) {
    return (
      <Grid
        container
        direction="row"
        wrap="wrap"
        alignItems="center"
        alignContent="center"
        className={classes.root}
      >
        <Grid item xs={12} style={{ padding: "15px", textAlign: "center" }}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => setPaymentView(false)}
          >
            {t("regresarADatos")}
          </Button>

          <Typography
            color="primary"
            gutterBottom
            variant={"h4"}
            component="h2"
          >
            {t("continuar")}
          </Typography>
          <PaymentsView
            currency={currency}
            currencyBase={currencyBase}
            callback={sendPayment}
            callbackCode={callbackProducts}
            order={currentOrder.order}
            currentOrder={currentOrder}
            eventDetail={eventDetail}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      direction="row"
      wrap="wrap"
      alignItems="center"
      alignContent="center"
      className={classes.root}
    >
      {personalData != null && (
        <div className={classes.root}>
          <Grid item xs={12} style={{ margin: "10px" }}>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setPersonalData(null)}
            >
              {t("regresarADatos")}
            </Button>
          </Grid>
          <Grid item xs={12} style={{ padding: "15px", textAlign: "center" }}>
            <Typography
              color="primary"
              gutterBottom
              variant={"h3"}
              component="h2"
            >
              {t("excelente", { nombre: personalData.nombres })}
            </Typography>
            <Typography
              color="primary"
              gutterBottom
              variant={"subtitle"}
              component="h5"
            >
              {t("puedesContinuarRegistro")}
            </Typography>
          </Grid>
          {showSecondForm && eventDetail && eventSubEventsRegistry && (
            <Grid item xs={12} style={{ padding: "15px" }}>
              <CurrencyPayment
                callback={setCurrency}
                currentCurrency={currency}
                currencyBase={currencyBase}
                registryConfiguration={registryConfigurationData}
              />
            </Grid>
          )}
          {!showProducts && (
            <Grid item xs={12} style={{ padding: "15px" }}>
              <FieldEvent
                fieldObject={formDistanceAndExtra.distancia}
                callback={confirmSubEvent}
                currentOrder={currentOrder}
                titlesColors={titlesColors}
              />
            </Grid>
          )}

          {/* {showSecondForm && eventDetail && eventSubEventsRegistry && (
          <Grid item xs={12} style={{ padding: "15px" }}>
              <FormRender
                callback={confirmSubEvent}
                formObject={formDistanceAndExtra}
                submitButtonText={"Confirmar y continuar con el pago"}
              />
            )
            //renderDistanceConfig(eventSubEventsRegistry)
          </Grid>
            } */}
          <Grid item xs={12} style={{ padding: "15px" }}>
            {eventDetail &&
              eventSubEventsRegistry &&
              registryConfigurationData &&
              currentOrder &&
              !showProducts && (
                <AditionalInputs
                  eventDetail={eventDetail}
                  eventSubEventsRegistry={eventSubEventsRegistry}
                  registryConfigurationData={registryConfigurationData}
                  currentOrder={currentOrder}
                  callbackInputs={callbackInputs}
                  profile={"Public"}
                />
              )}
            {eventDetail &&
              eventSubEventsRegistry &&
              registryConfigurationData &&
              currentOrder &&
              showProducts && (
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ width: "100%" }}
                    onClick={() => setShowProducts(false)}
                  >
                    {t("regresar")}
                  </Button>
                  <AditionalProducts
                    currentOrder={currentOrder}
                    callbackProducts={callbackProducts}
                  />
                </div>
              )}
            {eventDetail &&
              eventSubEventsRegistry &&
              registryConfigurationData &&
              currentOrder &&
              showProducts && (
                <Grid item xs={12} style={{ padding: "10px" }}>
                  <PaymentDetailRegistryForm
                    order={currentOrder.order}
                    currency={currency}
                    currencyBase={currencyBase}
                    removeItemOrder={() => false}
                  />
                </Grid>
              )}
            {/* <Grid item xs={12} style={{ padding: "10px" }}>
              <Button
                variant="contained"
                color="primary"
                style={{ padding: "15px", width: "100%" }}
              >
                Continuar con el pago
              </Button>
            </Grid> */}

            {showPaymentForm && showProducts && (
              <SaveAthleteDataView
                currency={currency}
                callback={() => setPaymentView(true)}
                callbackCode={callbackProducts}
                order={currentOrder.order}
                currentOrder={currentOrder}
                eventDetail={eventDetail}
                enGrupo={grupoAtletas.length > 0}
                onAddOther={agregarAtletaAlGrupo}
                onFinishGroup={finalizarGrupoConEsteAtleta}
              />
            )}
          </Grid>
        </div>
      )}
      {personalData == null && (
        <div>
          {avisoGrupoRecuperado > 0 && (
            <Grid item xs={12} style={{ padding: "10px", textAlign: "center" }}>
              <Typography color="primary" gutterBottom variant={"subtitle1"} component="h5">
                {t("grupoRecuperado", { count: avisoGrupoRecuperado })}
              </Typography>
              <Button
                color="primary"
                variant="contained"
                onClick={() => setShowGroupSummary(true)}
                style={{ margin: "5px" }}
              >
                {t("continuarConRegistros")}
              </Button>
              <Button onClick={cancelarGrupo} style={{ margin: "5px" }}>
                {t("descartarEmpezarDeNuevo")}
              </Button>
            </Grid>
          )}
          <Grid item xs={12} style={{ padding: "10px", textAlign: "center" }}>
            <Typography
              color="primary"
              gutterBottom
              variant={"h3"}
              component="h2"
            >
              {t("confirmaDatosRegistro")}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ margin: "15px", color: "white" }}>
            <FormRender
              callback={confirmPersonalData}
              formObject={form}
              submitButtonText={t("confirmarMisDatos")}
            />
          </Grid>
        </div>
      )}
    </Grid>
  );
}
